import {
    REQUEST_PROJECTS,
    REQUEST_PROJECTS_FULLFILED,
    THROW_REQUEST_PROJECTS_ERROR
} from "../types";

const defaultState = {
    data: {
        projects: []
    },
    fetching: false,
    error: false
};

const projectReducer = (state = defaultState, action) => {
    switch(action.type){
        case REQUEST_PROJECTS:
            return { ...state, fetching: true };
        case REQUEST_PROJECTS_FULLFILED:
            return { ...state, data: action.payload, fetching: false, error: false };
        case THROW_REQUEST_PROJECTS_ERROR:
            return { ...state, fetching: false, error: action.payload }
        default:
            return state;
    }
}

export default projectReducer;


// WEBPACK FOOTER //
// ./src/reducers/project-reducer.js